import React from "react"
import classNames from "classnames"
import { ViewLocation } from "../../../../../plate_viewer/coords"

type TitleHoverState = {
  openAt: ViewLocation
  title: string
}

const TitleHover = ({ state }: { state: TitleHoverState | null }) => {
  if (!state) return null
  return (
    <div
      id="title-hover"
      className={classNames(
        "absolute rounded-sm border border-zinc-300 bg-zinc-50 px-3 py-2 text-xs dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-100 max-w-md whitespace-nowrap text-ellipsis overflow-hidden"
      )}
      style={{
        left: `${state.openAt.vx}px`,
        top: `${state.openAt.vy}px`,
      }}
    >
      {state.title.split("\n")[0]}
    </div>
  )
}

export default TitleHover
export { TitleHoverState }
